// apps/web/src/lib/pendencia-remessa.ts — Fase 07, Plano 07 (OMIE-08, D-02, D-04, UI-SPEC).
import {
  deveExibirFinanceiro,
  type DadosFinanceiroBadgeInput,
  type SessionWithPermissions,
} from './financeiro-badge';

/**
 * Retorna o texto do aviso inline de pendência para exibição no formulário de Remessa.
 * Se o cliente estiver em situação regular, devolve null.
 */
export function mensagemPendencia(dados?: DadosFinanceiroBadgeInput | null): string | null {
  if (!dados) return null;

  if (dados.situacaoCredito?.bloqueado) {
    return 'Atenção: Cliente possui bloqueio ativo de faturamento na Omie.';
  }

  const temVencido = Number(dados.contasReceber?.totalVencido || 0) > 0;
  const isInadimplente = Boolean(dados.inadimplente || dados.situacaoCredito?.inadimplente || temVencido);

  if (isInadimplente) {
    return 'Atenção: Cliente com pendências financeiras e títulos vencidos na Omie.';
  }

  return null;
}

/**
 * Determina se a checagem assíncrona de pendência na Remessa deve ser disparada no frontend.
 * Disparada apenas para sessões com 'financeiro:consultar' (Gestão / Admin).
 */
export function deveVerificarPendencia(session?: SessionWithPermissions | null): boolean {
  return deveExibirFinanceiro(session);
}
